var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./MyADGAvailabilityPopup.jinja');
require('./MyADGAvailabilityPopup.less');

var moment = require('moment/moment');

var CommonCalendar = require('front/components/CommonCalendar/CommonCalendar');
var CommonCalendarTemplate = require('front/components/CommonCalendar/CommonCalendarRuntime.jinja');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        'click .MyADGAvailabilityPopup-listItemRadio': 'onRadioClick',
        'click .MyADGAvailabilityPopup-listItemDate': 'onDateClick',
        'click .MyADGAvailabilityPopup-update': 'onUpdateClick',
        'click .MyADGAvailabilityPopup-listItemInfo': 'onInfoClick',
        'change input[type="radio"]': 'onRadioChange'
    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        return Urls['member:api:availability']('json');
    },


    onRadioChange: function (e) {
        app.utils.fixSafariRadioRepaint(e);
    },


    renderData: function () {
        return {
            popup: {
                list: this.data.availability || {}
            }
        };
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onBodyClick');

        BasePopup.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        BasePopup.prototype.viewsRegistration.call(this);

        this.initialAvailabilityData = this.getAvailabilityData();
    },


    onInfoClick: function (e) {
        if (app.settings.isDesktop) return;

        if ($(e.target).closest('.MyADGAvailabilityPopup-listItemInfoPopup').length) return;

        if ($(e.currentTarget).hasClass('MyADGAvailabilityPopup-listItemInfo--active')) {
            this.closeAllInfoPopups();
        } else {
            this.closeAllInfoPopups();
            $(e.currentTarget).addClass('MyADGAvailabilityPopup-listItemInfo--active');
            $('body').on('click', this.onBodyClick);
        }
    },


    closeAllInfoPopups: function () {
        this.$('.MyADGAvailabilityPopup-listItemInfo').removeClass('MyADGAvailabilityPopup-listItemInfo--active');

        $('body').off('click', this.onBodyClick);
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.MyADGAvailabilityPopup-listItemInfo').length) return;

        this.closeAllInfoPopups();
    },



    getAvailabilityData: function () {
        var $items = this.$('.MyADGAvailabilityPopup-listItem');
        var data = [];

        $items.each(function (ind, item) {
            var $item = $(item);
            var itemData = {};
            var isLimited = $item.attr('data-limited') == '1';

            itemData.selected = $item.attr('data-available') == '1';
            itemData.id = parseInt($item.find('.MyADGAvailabilityPopup-listItemPosition').attr('data-position'), 10);

            if (itemData.selected && !isLimited) {
                const start = $item.find('.MyADGAvailabilityPopup-listItemDate[data-type="from"]').attr('data-date');
                itemData.start = start ? moment(start).format() : null;
                const end = $item.find('.MyADGAvailabilityPopup-listItemDate[data-type="to"]').attr('data-date');
                itemData.end = end ? moment(end).format() : null;
            }

            data.push(itemData);
        }.bind(this));

        return data;
    },


    onDateClick: function (e) {
        var $date = $(e.currentTarget);
        var $item = $date.closest('.MyADGAvailabilityPopup-listItem');
        var isLimited = $item.attr('data-limited') == '1';
        var tp = $date.attr('data-type');

        if ($date.hasClass('MyADGAvailabilityPopup-listItemDate--calendar-opened')) {
            return;
        }

        var $calendar = $(CommonCalendarTemplate.render({data: {}}));

        $date.append($calendar);

        $date.addClass('MyADGAvailabilityPopup-listItemDate--calendar-opened');

        var calendar = new CommonCalendar({
            el: $calendar[0],
            date: $date.attr('data-date'),
            allowPastDates: false
            //warning: isLimited ? 'Art Directors, Scenic Title Graphic Artists and Set Designers can only set availability up to one month.' : ''
        });

        calendar.show();

        calendar.on('close', function () {
            calendar.off();
            $date.removeClass('MyADGAvailabilityPopup-listItemDate--calendar-opened');
        });

        calendar.on('select', function (date) {
            var dateTo;
            var dateFrom;
            if (tp == 'from') {
                dateFrom = moment(date).startOf('day');
                dateTo = this.getToDate(dateFrom, isLimited);
            } else {
                dateFrom = moment($item.find('.MyADGAvailabilityPopup-listItemDate[data-type="from"]').attr('data-date'));
                dateTo = moment(date).endOf('day');
                if (dateTo < dateFrom) {
                    dateFrom = dateTo;
                }
            }

            $item
                .find('.MyADGAvailabilityPopup-listItemDate[data-type="from"]')
                .attr('data-date', dateFrom.toISOString())
                .find('span')
                .text(dateFrom.format('MM/DD/YY'));

            $item
                .find('.MyADGAvailabilityPopup-listItemDate[data-type="to"]')
                .attr('data-date', dateTo.toISOString())
                .find('span')
                .text(dateTo.format('MM/DD/YY'));

            this.updateButtonState();
        }.bind(this));
    },


    onUpdateClick: function () {

        if (this.$('.MyADGAvailabilityPopup-update').hasClass('MyADGAvailabilityPopup-update--saved')) {
            return;
        }

        var data = this.getAvailabilityData();

        this.$('.MyADGAvailabilityPopup-update').addClass('Button--loading');

        this._xhr = $.ajax({
            'url': Urls['member:api:availability']('json'),
            'contentType': 'application/json; charset=utf-8',
            'data': JSON.stringify({
                'availability': data
            }),
            'dataType': 'json',
            'method': 'PUT',
            'success': function (data) {
                this.initialAvailabilityData = this.getAvailabilityData();
                // this.updateButtonState();
                this.$('.MyADGAvailabilityPopup-update').removeClass('Button--loading');
                this.$('.MyADGAvailabilityPopup-update').addClass('MyADGAvailabilityPopup-update--saved');
                app.vent.trigger('need-reload', 'my-adg');
            }.bind(this),
            'error': function () {
                alert('Something went wrong, try again later.');
                this.$('.MyADGAvailabilityPopup-update').removeClass('Button--loading');
            }.bind(this),
            'context': this
        });
    },


    onRadioClick: function (e) {
        var $radio = $(e.currentTarget);
        var $item = $radio.closest('.MyADGAvailabilityPopup-listItem');
        var isAvailable = $radio.attr('data-switch') == '1';
        var isLimited = $item.attr('data-limited') == '1';
        var slideSpeed = 300;

        if (!isAvailable) {
            $item.attr('data-available', '0');

            if (!isLimited) {
                $item.removeClass('MyADGAvailabilityPopup-listItem--dates');
                $item.find('.MyADGAvailabilityPopup-listItemDate[data-type="to"]').slideUp(slideSpeed);
                $item.find('.MyADGAvailabilityPopup-listItemDate[data-type="from"]').slideUp(slideSpeed);
            }
        } else {
            $item.attr('data-available', '1');

            if (!isLimited) {
                $item.addClass('MyADGAvailabilityPopup-listItem--dates');
                $item.find('.MyADGAvailabilityPopup-listItemDate[data-type="to"]').slideDown(slideSpeed);
                $item.find('.MyADGAvailabilityPopup-listItemDate[data-type="from"]').slideDown(slideSpeed);

                var dateFrom = moment().startOf('day');
                var dateTo = this.getToDate(dateFrom, isLimited);

                $item
                    .find('.MyADGAvailabilityPopup-listItemDate[data-type="from"]')
                    .attr('data-date', dateFrom.toISOString())
                    .find('span')
                    .text(dateFrom.format('MM/DD/YY'));

                $item
                    .find('.MyADGAvailabilityPopup-listItemDate[data-type="to"]')
                    .attr('data-date', dateTo.toISOString())
                    .find('span')
                    .text(dateTo.format('MM/DD/YY'));
            }
        }

        this.updateButtonState();
    },


    getToDate: function (fromDate, isLimited) {
        var dt = fromDate.clone();
        var endOfFromMonth = fromDate.clone().endOf('month');

        if (isLimited) {
            if (dt.get('date') < endOfFromMonth.get('date') - 5) {
                dt.endOf('month');
            } else {
                dt.add(1, 'month').endOf('month');
            }
        } else {
            dt.add(1, 'month').endOf('month');
        }

        return dt;
    },


    updateButtonState: function () {
        this.availabilityData = this.getAvailabilityData();

        var errorDates = false;
        _.each(this.availabilityData, function (item) {
            if (item.hasOwnProperty('start') && !item.start) errorDates = true;
            if (item.hasOwnProperty('end') && !item.end) errorDates = true;
        });

        this.$('.MyADGAvailabilityPopup-update')
            .toggleClass('MyADGAvailabilityPopup-update--visible', !errorDates && JSON.stringify( this.initialAvailabilityData) != JSON.stringify(this.availabilityData));

        this.$('.MyADGAvailabilityPopup-update').removeClass('MyADGAvailabilityPopup-update--saved');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MyADGAvailabilityPopup/MyADGAvailabilityPopup.js
// module id = 280
// module chunks = 0